import { createContext, use } from 'react';

export type ToastKind = 'info' | 'error';

export interface ToastApi {
  push: (message: string, kind?: ToastKind) => void;
}

export const ToastContext = createContext<ToastApi | null>(null);

export function useToasts(): ToastApi {
  const value = use(ToastContext);
  if (!value) throw new Error('useToasts used outside ToastProvider');
  return value;
}
